import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from 'src/app/core/services/api.service';

@Injectable({
    providedIn: 'root'
})
export class CarrierNameService extends ApiService {

    public getByCarrierId(carrierId: number): Observable<any> {
        return this.request({
            method: 'GET',
            path: `carrier-names/${carrierId}`,
        });
    }

    public create(carrierId: number, name: string): Observable<any> {
        return this.request({
            method: 'POST',
            path: `carrier-names/${carrierId}`,
            body: { name },
        });
    }

    public delete(id: number): Observable<any> {
        return this.request({
            method: 'DELETE',
            path: `carrier-names/${id}`,
        });
    }
}
